import { render } from "./my-quotes-page.vue?vue&type=template&id=d6452aa0"
import script from "./my-quotes-page.vue?vue&type=script&lang=js"
export * from "./my-quotes-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__